export default __webpack_public_path__ + "static/media/rocket_anim_129.d2fe714c.png";